import { api } from './client.ts';
import type { CompanyAddOn, CreateAddOnInput, UpdateAddOnInput } from '@shared/add-ons.ts';

/** Saved add-ons, Settings › Pricing (migration 0093). */
export const addOnsApi = {
  list: (includeArchived = false, signal?: AbortSignal) =>
    api.getFresh<{ items: CompanyAddOn[] }>(
      `/settings/add-ons${includeArchived ? '?includeArchived=true' : ''}`,
      signal,
    ),
  create: (input: Partial<CreateAddOnInput> & Pick<CreateAddOnInput, 'name' | 'defaultAmountCents'>) =>
    api.post<CompanyAddOn>('/settings/add-ons', input),
  update: (id: string, input: UpdateAddOnInput) => api.patch<CompanyAddOn>(`/settings/add-ons/${id}`, input),
  archive: (id: string) => api.post<CompanyAddOn>(`/settings/add-ons/${id}/archive`),
  restore: (id: string) => api.post<CompanyAddOn>(`/settings/add-ons/${id}/restore`),
  reorder: (ids: string[]) => api.put<{ items: CompanyAddOn[] }>('/settings/add-ons/order', { ids }),
};
